

export function setAccountsFrom(state, accounts_from) {
    state.accounts_from = accounts_from
}

export function setContacts(state, contacts) {
    state.contacts = contacts;
}
export function setstate_finanze(state, state_finaze) {
    state.state_finaze = state_finaze
}
export function setParams(state, params){
    state.params = params
}


// WEBPACK FOOTER //
// ./src/modules/estados-financieros/mutations.js